module.exports = __webpack_public_path__ + "static/media/aldric.dafbbc81.png";